import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetAPI, callPostAPI, callPutAPI } from '../../services/axios';

export const getTodaysVisits = createAsyncThunk(
	'getTodaysVisits',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/visit', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getPastVisits = createAsyncThunk(
	'getPastVisits',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/visit', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getAllVisits = createAsyncThunk(
	'getAllVisits',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/visit', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getVisitById = createAsyncThunk(
	'getVisitById',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/visit/get-details', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getComplains = createAsyncThunk(
	'getComplains',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/complaints', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getFrequencies = createAsyncThunk(
	'getFrequencies',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/frequency', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getDurations = createAsyncThunk(
	'getDurations',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/duration', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getSeverities = createAsyncThunk(
	'getSeverities',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/severity', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getDiagnosis = createAsyncThunk(
	'getDiagnosis',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/diagnosis', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getMedicine = createAsyncThunk(
	'getMedicine',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/medicines/options', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);
// dose, timing, frequency, duration
export const getDose = createAsyncThunk(
	'getDose',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/dose', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getTiming = createAsyncThunk(
	'getTiming',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/timing', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getTestRequired = createAsyncThunk(
	'getTestRequired',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/test', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getAdvice = createAsyncThunk(
	'getAdvice',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/advice', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getDietExercises = createAsyncThunk(
	'getDietExercises',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/diet-exerise', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getTestDeadline = createAsyncThunk(
	'getTestDeadline',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/allopathy/test-deadline', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getGeneral = createAsyncThunk(
	'getGeneral',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/sys-examination?type=general', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getCvs = createAsyncThunk(
	'getCvs',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/sys-examination?type=cvs', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getRs = createAsyncThunk(

	'getRs',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/sys-examination?type=rs', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getCns = createAsyncThunk(
	'getCns',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/sys-examination?type=cns', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getPa = createAsyncThunk(
	'getPa',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/sys-examination?type=pa', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getEnt = createAsyncThunk(
	'getEnt',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/sys-examination?type=ent', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const createVisit = createAsyncThunk(
	'createVisit',
	async(params, { rejectWithValue }) => {
		try {
			const response = await callPostAPI({ route: 'hospital/visit', body: params });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const updateVisit = createAsyncThunk(
	'updateVisit',
	async(params, { rejectWithValue }) => {
		try {
			const response = await callPutAPI({ route: `hospital/visit/${params.visitId}`, body: params.payload });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getLastVisit = createAsyncThunk(
	'getLastVisit',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/visit/get-last-visit', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getVisitPdf = createAsyncThunk(
	'getVisitPdf',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/visit/download', params: newParams,
				options: {
					responseType: 'blob'
				}
			});
			return response.data;
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const sendEmail = createAsyncThunk(
	'sendEmail',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/visit/send-mail', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getSharableLink = createAsyncThunk(
	'getSharableLink',
	async(params, { rejectWithValue }) => {
		try {
			const { ...newParams } = params;
			const response = await callGetAPI({ route: 'hospital/visit/generate-shareable-link', params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);